<template >
  <VirtualColumn v-if="!!config.show" :prop="config.prop" :label="config.label" :width="fill ? undefined :config.width" :minWidth="config.minWidth"
    :vfixed="config.fixed" :align="config.align">
    <template slot="header">
      <slot name="header">
        {{ config.label }}
      </slot>
    </template>

    <template slot-scope="{ row }">
      <slot name="content" :row="row">
        {{ row[config.prop] }}
      </slot>
    </template>
  </VirtualColumn>
</template>


<script>
import { VirtualColumn } from 'el-table-virtual-scroll'

export default {
  name: "CustomColumn",
  props: {
    config: Object,
    tableStorageKey: String,
    fill: Boolean,
  },
  components: {
    VirtualColumn,
  },
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: { },

  watch: { },

};
</script>


<style lang='scss' scoped></style>